import { twMerge } from 'tailwind-merge'

import { Icon, IconNameAndCategoryString } from '../../Icon'
import Label from './Label'

const getIcon = (size: 'sm' | 'md' | 'lg'): IconNameAndCategoryString => {
    switch (size) {
        case 'sm':
            return 'close.small'
        case 'md':
            return 'close.medium'
        case 'lg':
            return 'close.large'
    }
}

export type TagProps = React.ComponentPropsWithoutRef<'div'> & {
    label: string
    size?: 'sm' | 'md' | 'lg'
    intent?: 'success' | 'warning' | 'danger' | 'info' | 'default' | 'muted' | 'purple'
    onClose?: () => void
}

function Tag({ label, className, size = 'md', intent = 'default', onClose, ...props }: TagProps) {
    const sizeClasses = {
        sm: 'px-2 py-0.5',
        md: 'px-3 py-1',
        lg: 'px-4 py-1.5',
    }

    const intentClasses = {
        success: 'bg-success-100 text-success-400',
        warning: 'bg-warning-100 text-warning-600',
        danger: 'bg-danger-100 text-danger-400',
        info: 'bg-info-100 text-info-400',
        muted: 'bg-gray-100 text-gray-500',
        default: 'bg-gray-100 text-gray-700',
        purple: 'bg-purple-100 text-purple-400',
    }

    return (
        <div
            role="tag"
            className={twMerge(
                'flex w-fit items-center gap-2 rounded-full border-2 border-white text-xs whitespace-nowrap text-gray-700',
                sizeClasses[size],
                intentClasses[intent],
                className
            )}
            {...props}
        >
            <Label size={size}>{label}</Label>
            {onClose && (
                <Icon
                    icon={getIcon(size)}
                    shouldInheritColor
                    className="cursor-pointer"
                    onClick={onClose}
                />
            )}
        </div>
    )
}

export default Tag
